'use strict';

var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

var IndexSection = require('components/IndexSection/IndexSection');

require('./IndexContact.less');


module.exports = IndexSection.extend({

    //is next section on show animation lies under or moves from outside
    NEXT_SECTION_MOVE: true,

    el: '.IndexContact',

    events: _.extend({
        'mouseenter .IndexContact-link': 'onLinkMouseenter',
        'mouseleave .IndexContact-link': 'onLinkMouseleave'
    }, IndexSection.prototype.baseEvents),

    initialize: function (options) {

        _.bindAll(this, 'onResourcesReady');

        this.resources = {};

        if (app.settings.isDesktop) {
            this.resources['whatwedo-video'] = app.staticPath + 'img/IndexContact/whatwedo.mp4',
            this.resources['contact-video'] = app.staticPath + 'img/IndexContact/contact.mp4'
        }

        this.on('resources-ready', this.onResourcesReady);

        IndexSection.prototype.initialize.call(this, options);
    },


    onResourcesReady: function() {
        if (this.resources['whatwedo-video']) {
            var $video = $('<video class="IndexContact-video" data-type="work" muted playsinline crossorigin loop preload="auto"></video>');
            $video.attr('src', this.resources['whatwedo-video']);
            this.$('.IndexContact-videoWrapper').append($video);
        }

        if (this.resources['contact-video']) {
            var $video = $('<video class="IndexContact-video" data-type="contact" muted playsinline crossorigin loop preload="auto"></video>');
            $video.attr('src', this.resources['contact-video']);
            this.$('.IndexContact-videoWrapper').append($video);
        }


        _.each(this.$('.IndexContact-titleText'), function (item, index) {
            var chars = $(item).data('text').split('');

            _.each(chars, function (char) {
                if (char === ' ') char = '&nbsp;';
                $(item).append('<span>' + char + '</span>');
            });
        });
    },


    onLinkMouseenter: function (e) {
        if (!app.settings.isDesktop) return;

        var $link = $(e.currentTarget);
        var type = $link.data('type');
        var oppositeType = type === 'work' ? 'contact' : 'work';

        //styling headers
        this.$('.IndexContact-title').addClass('isTransparent');
        this.$('.IndexContact-title').addClass('noArrow');

        //show video
        var $video = this.$('.IndexContact-video[data-type=' + type + ']');
        $video[0].play();
        $video.fadeIn();
    },


    onLinkMouseleave: function (e) {
        if (!app.settings.isDesktop) return;

        var $link = $(e.currentTarget);
        var type = $link.data('type');

        //styling headers
        this.$('.IndexContact-title').removeClass('isTransparent');
        this.$('.IndexContact-title').removeClass('noArrow');

        //show video
        this.$('.IndexContact-video').fadeOut();
        var $video = this.$('.IndexContact-video[data-type=' + type + ']');
        $video[0].pause();
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/components/IndexContact/IndexContact.js
 ** module id = 20
 ** module chunks = 0
 **/